import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import FibraOscura from "../views/FibraOscura.vue"
import Servicio from "../views/Servicio.vue"
import Contact from "../views/Contact.vue"
import RentaServicios from "../views/RentaServicios.vue"
import DuenosArrendadores from "../views/DuenosArrendadores.vue"
import TerminosyCondiciones from "../views/TerminosyCondiciones.vue"
import PorQue from "../views/PorQue.vue"
import Blog from "../views/Blog.vue"
import Producto from "../views/Producto.vue"
import Post from "../views/Post.vue"
import Academy from "../views/Academy.vue"



Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/servicios/:url',
    name: 'Servicio',
    component: Servicio
  },
  {
    path: '/servicios/fibra-oscura',
    name: 'Fibra Oscura',
    component: FibraOscura
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: Contact
  },
  {
    path: '/duenos-y-arrendadores',
    name: 'Duenos y Arrendadores',
    component: DuenosArrendadores
  },
  {
    path: '/renta-servicios',
    name: 'Renta Servicio',
    component: RentaServicios
  },
  {
    path: '/terminos-y-condiciones',
    name: 'Terminos y Condiciones',
    component: TerminosyCondiciones
  },
  {
    path: '/productos',
    name: 'Productos',
    component: Producto
  },
  {
    path: '/por-que-neutralNetwors',
    name: 'Por que nosotros',
    component: PorQue
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/academy',
    name: 'Academy',
    component: Academy
  },
  {
    path: '/blog/:url',
    name: 'Post',
    component: Post
  },
  {
    path: '/acerca-de',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
